import { render, staticRenderFns } from "./CveTrendTableCell.vue?vue&type=template&id=1d2322e6&scoped=true"
import script from "./CveTrendTableCell.vue?vue&type=script&lang=js"
export * from "./CveTrendTableCell.vue?vue&type=script&lang=js"
import style0 from "./CveTrendTableCell.vue?vue&type=style&index=0&id=1d2322e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2322e6",
  null
  
)

export default component.exports